document.addEventListener('scroll', function () {
    const header = document.querySelector('.header-wrapper');
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;

    if (scrollPosition > 0) {
        // スクロールされたときに背景色を #C0A275 に変更
        header.style.backgroundColor = '#F2E6D3';
    } else {
        // 最上位に戻ったときに背景を再び透明にする
        header.style.backgroundColor = 'transparent';
    }
});

document.addEventListener('scroll', function () {
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    const textElements = document.querySelectorAll(
        '.header__icon,' +
        '.header__heading-link .h2,' +
        '.header__icon--search,' +
        '.header__icon--summary,' +
        '.link,' +
        '.focus-inset,' +
        '.modal__toggle'
    );

    textElements.forEach(element => {
        if (scrollPosition > 0) {
            // スクロールされたときにテキストカラーを #000 に変更
            element.style.color = '#000';
        } else {
            // 最上位に戻ったときにテキストカラーを再び #fff に戻す
            element.style.color = '#fff';
        }
    });
});
